import { useState, useEffect } from 'react';
import { ExperienceModel } from '../models/experienceModel';
import { useLanguage } from '../i18n/LanguageContext';

export function useExperienceController() {
  const { selectedLanguage } = useLanguage();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);

    ExperienceModel.fetch(selectedLanguage)
      .then(d => {
        if (active) setData(d);
      })
      .catch(e => {
        if (active) setError(e);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [selectedLanguage]);

  return { data, loading, error };
}
